// src/Buttons/ServicosButton.js

import React from 'react';
import { Link } from 'react-router-dom';
import './ServicosButton.css';

export default function ServicosButton({ currentPath, buttonPath }) {
  const isActive = currentPath === buttonPath;

  return (
    <Link
      to={buttonPath}
      className={`ServicosButton ${isActive ? 'active' : ''}`}
    >
      SERVIÇOS
    </Link>
  );
}
